<template>
  <a-card>
    <div style="text-align: right;">
      <span
        class="ant-descriptions-title"
        style="float: left; margin-top: 5px;"
      >
        <a-icon type="question-circle" /> Phân quyền văn bản
      </span>
      <a-button type="primary" @click="addDocumentConfig">
        <a-icon type="plus" /> Thêm
      </a-button>
    </div>

    <a-drawer
      v-if="visibleAdd"
      title="Thêm cấu hình"
      placement="right"
      :visible="visibleAdd"
      @close="closeDrawerAdd"
      :width="450"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <AddDocumentConfig
        :addDocumentConfigOnView="addDocumentConfigOnView"
        :closeDrawerAdd="closeDrawerAdd"
      />
    </a-drawer>

    <a-drawer
      :width="450"
      v-if="visibleUpdate"
      title="Chỉnh sửa"
      placement="right"
      :visible="visibleUpdate"
      @close="closeDrawerUpdate"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <UpdateDocumentConfig
        :detailDocumentConfig="detailDocumentConfig"
        :updateDocumentConfigOnView="updateDocumentConfigOnView"
        :deleteDocumentConfigOnView="deleteDocumentConfigOnView"
        :closeDrawerUpdate="closeDrawerUpdate"
      />
    </a-drawer>

    <a-table
      :pagination="false"
      size="small"
      :columns="columnDepartment"
      :data-source="listDocumentConfig"
      :loading="tableLoading"
      rowKey="id"
    >
      <div slot="titles" slot-scope="text, record">
        <div v-if="record.title === 'DRAFTERS'">Người soạn thảo</div>
        <div v-if="record.title === 'DRAFTMANAGER'">
          Trưởng phòng văn thư
        </div>
        <div v-if="record.title === 'BOD'">
          Ban giám đốc
        </div>
      </div>

      <div slot="users" slot-scope="text, record">
        <span v-for="(item, i) in record.users" :key="item.id">
          {{ item.fullname || item.username }}
          <span v-if="i < record.users.length - 1">,</span>
        </span>
      </div>

      <div slot="createdAt" slot-scope="text, record">
        {{ record.createdAt | formatDateHour }}
      </div>

      <div slot="updatedAt" slot-scope="text, record">
        {{ record.updatedAt | formatDateHour }}
      </div>

      <div slot="author" slot-scope="text, record">
        {{ record.author && record.author.fullname }}
      </div>
      <div slot="action" slot-scope="text, record">
        <a-button @click="updateDocumentConfig(record)" icon="edit">
          Chỉnh sửa
        </a-button>
      </div>
    </a-table>
  </a-card>
</template>
<script>
import AddDocumentConfig from "./addDocumentConfig";
import UpdateDocumentConfig from "./updateDocumentConfig";
import getQuery from "../data/getData";
import { columnDepartment } from "../Constants/dataColumns";
export default {
  components: {
    AddDocumentConfig,
    UpdateDocumentConfig,
  },
  data() {
    return {
      columnDepartment,
      visibleAdd: false,
      visibleUpdate: false,
      tableLoading: true,
      listDocumentConfig: [],
      detailDocumentConfig: {},
    };
  },
  methods: {
    getAllDocumentConfig() {
      this.tableLoading = true;
      this.$apollo
        .query({
          query: getQuery.queryGetAllDocumentConfig,
          variables: {},
        })
        .then(({ data }) => {
          if (data?.getListDocumentConfig) {
            this.listDocumentConfig = data.getListDocumentConfig;
            console.log("data", data.getListDocumentConfig);
          }
          this.tableLoading = false;
        })
        .catch((error) => {
          console.log("Không lấy được danh sách phòng ban", error);
        });
    },
    addDocumentConfigOnView(documentConfig) {
      this.listDocumentConfig.unshift(documentConfig);
    },
    updateDocumentConfigOnView(documentConfig) {
      this.listDocumentConfig = this.listDocumentConfig.map((item) => {
        if (item.id === documentConfig.id) {
          return (item = { ...documentConfig });
        }
        return item;
      });
    },
    deleteDocumentConfigOnView(documentConfig) {
      this.listDocumentConfig = this.listDocumentConfig.filter(
        (item) => item.id !== documentConfig.id
      );
    },
    updateDocumentConfig(record) {
      this.visibleUpdate = true;
      this.detailDocumentConfig = record;
    },
    closeDrawerUpdate() {
      this.visibleUpdate = false;
    },
    addDocumentConfig() {
      this.visibleAdd = true;
    },
    closeDrawerAdd() {
      this.visibleAdd = false;
    },
  },
  created() {
    this.getAllDocumentConfig();
  },
};
</script>
<style></style>
